import { render, staticRenderFns } from "./Revenues.vue?vue&type=template&id=9447d812&"
import script from "./Revenues.vue?vue&type=script&lang=js&"
export * from "./Revenues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports